/**
 *
 * @param html string
 * @return string
 */
export const stripeHtmlTagsExceptLinks = (html: string):string => html.replace(/(<\/?a[^>]*>)|<[^>]+>/gi, '$1');
